<template>
  <div class="setting-body">
    <div class="setting-body-title m-b-20">{{ routerTitle }}</div>
    <div class="joined-company">
      <p style="text-align: left">
        已加入企业数量：{{ companyList.length || 0 }}（个）
      </p>

      <jczh-table-content :data="companyList" :option="option" height="600">
        <template v-slot:last>
          <el-table-column label="操作" align="center" width="150px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="enterCompany(row)">进入</el-button>
            </template>
          </el-table-column>
        </template>
      </jczh-table-content>
    </div>
  </div>
</template>

<script>
import { enterCompanyApi } from '@/api/employee'
import { companyStatusDict, employeeStatusDict } from '@/dictionary'
import { mapState } from 'vuex'
import personalMixin from '@/views/personal-center/personalMixin'

export default {
  name: 'JoinedCompany',

  mixins: [personalMixin],

  data() {
    return {
      returnUrl: this.$route.query.returnUrl,
      option: [
        {
          label: '企业名称',
          prop: 'companyName',
          minWidth: '200px'
        },
        {
          label: '员工姓名',
          prop: 'name',
          minWidth: '100px'
        },
        {
          label: '员工邮箱',
          prop: 'email',
          minWidth: '150px'
        },
        {
          label: '员工状态',
          prop: 'employeeStatus',
          width: '150px',
          tagDict: employeeStatusDict
        }
      ]
    }
  },

  computed: {
    ...mapState('user', ['companyList']),

    translateStatus() {
      return status => {
        return employeeStatusDict.translate(status)
      }
    }
  },

  created() {
    this.$store.dispatch('user/getJoinedCompany')
  },

  methods: {
    enterCompany(company) {
      if (company.companyStatus === companyStatusDict.DISABLED.value) {
        this.$message.warning('当前企业已被禁用，请选择其它企业')
        return
      }
      const temp = {
        employeeId: company.employeeId,
        companyId: company.companyId
      }
      enterCompanyApi(temp)
        .then(res => {
          if (res.success) {
            // 登录成功后跳转
            window.location.href =
              this.returnUrl || `${process.env.VUE_APP_LOGIN_JUMP_URL}`
          }
        })
        .catch(err => {
          this.$message.error(err.data.message || '登录企业失败，请稍后重试')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-body {
  width: 1030px;
  padding: 20px;
  background-color: $white-color;
  overflow: hidden;
  position: relative;

  .setting-body-title {
    text-align: left;
    font-size: 20px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 25px;
      background-color: $primary-color;
      vertical-align: bottom;
      margin-right: 10px;
    }
  }
}
</style>
